export const CHAT_LOAD_START = 'CHAT_LOAD_START';
export const CHAT_LOAD_FINISH = 'CHAT_LOAD_FINISH';
export const CHAT_LOAD_ERROR = 'CHAT_LOAD_ERROR';

export const CHAT_UPDATE_START = 'CHAT_UPDATE_START';
export const CHAT_UPDATE_FINISH = 'CHAT_UPDATE_FINISH';
export const CHAT_UPDATE_ERROR = 'CHAT_UPDATE_ERROR';
